import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, Link } from "react-router-dom";
import { ViewUserAppointment } from "../../Redux/Actions/homeVisitActions";
import { ToFirstCapital } from "../../Utils/helpers";
import { ReactComponent as BackIcon } from "../../Assets/Categories/BackIcon.svg";
import SearchBar from "../Main/searchBar";
import { Skeleton, Modal } from "antd";
import "./viewHomeVisit.css";

// const ReviewText = ({ text, maxWidth = "250px" }) => {
//   const [isOverflow, setIsOverflow] = useState(false);
//   const [isExpanded, setIsExpanded] = useState(false);
//   const textRef = useRef(null);

//   useEffect(() => {

//     const checkOverflow = () => {
//       if (textRef.current) {
//         setIsOverflow(
//           textRef.current.scrollWidth > textRef.current.clientWidth
//         );
//       }
//     };

//     checkOverflow();
//     window.addEventListener("resize", checkOverflow);
//     return () => window.removeEventListener("resize", checkOverflow);
//   }, [text]);

//   const toggleExpand = () => setIsExpanded(!isExpanded);

//   if (!text || text === "N/A") return <span className="info-value">N/A</span>;

//   return (
//     <div className="info-value" style={{ maxWidth, overflow: "hidden" }}>
//       <div
//         ref={textRef}
//         style={{
//           display: "flex",
//           alignItems: "center",
//           gap: "8px",
//           whiteSpace: isExpanded ? "normal" : "nowrap",
//           overflow: "hidden",
//         }}
//       >
//         <span
//           style={{
//             flex: isExpanded ? "none" : 1,
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             wordBreak: isExpanded ? "break-word" : "normal",
//           }}
//         >
//           {isExpanded ? text : text}
//         </span>
//         {isOverflow && !isExpanded && (
//           <button
//             onClick={toggleExpand}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#007bff",
//               cursor: "pointer",
//               fontSize: "14px",
//               padding: "0 4px",
//               whiteSpace: "nowrap",
//               fontWeight: 500,
//             }}
//             title="View More"
//           >
//             View More
//           </button>
//         )}
//         {isExpanded && (
//           <button
//             onClick={toggleExpand}
//             style={{
//               background: "none",
//               border: "none",
//               color: "#007bff",
//               cursor: "pointer",
//               fontSize: "14px",
//               padding: "0 4px",
//               whiteSpace: "nowrap",
//               fontWeight: 500,
//             }}
//             title="View Less"
//           >
//             View Less
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

const ViewHomeVisit = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [isReviewModalOpen, setIsReviewModalOpen] = useState(false);
  const appointment = useSelector((state) => state.homeVisit || {});
  const loading = appointment?.loading;
  const data = appointment?.appointment || {};

  const latitude = data?.location?.coordinates?.[1];
  const longitude = data?.location?.coordinates?.[0];

  useEffect(() => {
    if (id) {
      dispatch(ViewUserAppointment(id));
    }
  }, [dispatch, id]);

  return (
    <div className="view-agent-container-new">
      {/* Header - UNCHANGED */}
      <div className="searchbar-wrapper">
        <div className="searchbar-container">
          <SearchBar />
        </div>
      </div>

      <div className="view-agent-header back-icon margin-0 gap-10 align-center flex-container">
        <Link to="/home_visit">
          <BackIcon style={{ cursor: "pointer" }} />
        </Link>
        <div className="view-agent-title-section referral-view">
          <h3 className="view-agent-main-title">Agent Profile Details</h3>
          <h4 className="view-agent-breadcrumb">Agent / List / View</h4>
        </div>
      </div>

      {/* Content - REDESIGNED */}
      {loading ? (
        <div className="agent-content-new">
          <Skeleton active paragraph={{ rows: 10 }} />
        </div>
      ) : (
        <div className="agent-content-new">
          {/* Top Profile Card */}
          <div className="agent-profile-header">
            <div className="agent-profile-main">
              <div className="agent-avatar-placeholder">
                {data?.user?.user_id?.charAt(0) || "U"}
              </div>

              <div className="agent-profile-info">
                <h1 className="agent-name">
                  {data?.user?.user_id || "N/A"}
                </h1>
                <div className="agent-id-badge">
                  OTP: {data?.otp || "—"}
                </div>
              </div>
            </div>

            <div className="agent-status-control">
              <label className="status-label" style={{ marginLeft: "50px"}}>Status</label>
              <div
                className={`status-badge status-${data?.status?.toLowerCase() || "pending"
                  }`}
              >
                {ToFirstCapital(data?.status) || "Pending"}
              </div>
            </div>
          </div>

          {/* Details Grid */}
          <div className="agent-details-grid">
            {/* User Details Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px"}}>👤 User Details</h3>

              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Name</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>{data?.user?.name || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">Email</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>{data?.user?.email || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">User ID</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>{data?.user?.user_id || "—"}</span>
                </div>

                <div className="info-row">
                  <span className="info-label">Phone</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.user?.country_code && data?.user?.contact_number
                      ? `${data.user.country_code} ${data.user.contact_number}`
                      : "—"}
                  </span>
                </div>

                {data?.user?.profile_image && (
                  <div className="info-row">
                    <span className="info-label">Profile Image</span>
                    <img
                      src={data.user.profile_image}
                      alt={data.user.name}
                      className="user-profile-image"
                    />
                  </div>
                )}
              </div>
            </div>

            {/* Assigned Agent */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px"}}>👨‍💼 Assigned Agent</h3>

              <div className="card-content">
                {data?.agent ? (
                  <>
                    <div className="info-row">
                      <span className="info-label">Name</span>
                      <span className="info-value" style={{ fontSize: "15px"}}>{data.agent.name}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Agent ID</span>
                      <span className="info-value" style={{ fontSize: "15px"}}>{data.agent.staff_id}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Email</span>
                      <span className="info-value" style={{ fontSize: "15px"}}>{data.agent.email}</span>
                    </div>

                    <div className="info-row">
                      <span className="info-label">Phone</span>
                      <span className="info-value" style={{ fontSize: "15px"}}>
                        {data.agent.country_code} {data.agent.contact_number}
                      </span>
                    </div>
                  </>
                ) : (
                  <div className="info-row">
                    <span className="info-value" style={{ fontSize: "15px"}}>No agent assigned</span>
                  </div>
                )}
              </div>
            </div>

            {/* Appointment Info Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px"}}>📅 Appointment Details</h3>

              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Date & Time</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.appointment_date
                      ? new Date(data.appointment_date).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })
                      : "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Rating</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.rating > 0 ? (
                      <span className="star-rating">
                        {Array.from(
                          { length: data.rating_by_user_to_agent },
                          (_, i) => (
                            <span key={i}>⭐</span>
                          )
                        )}
                      </span>
                    ) : (
                      "—"
                    )}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Created At</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.created_at
                      ? new Date(data.created_at).toLocaleString("en-US", {
                        dateStyle: "medium",
                        timeStyle: "short",
                      })
                      : "—"}
                  </span>
                </div>

                <div className="review-section-wrapper">
                  <div className="review-label-row">
                    <span className="info-label">REVIEW OF USER</span>
                    {data?.review_by_user_to_agent && data.review_by_user_to_agent !== "N/A" && (
                      <button
                        className="review-expand-icon"
                        onClick={() => setIsReviewModalOpen(true)}
                        title="Expand review"
                      >
                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                      </button>
                    )}
                  </div>
                  <div className="review-text-container">
                    {data?.review_by_user_to_agent && data.review_by_user_to_agent !== "N/A" ? (
                      <p className="review-text-content">
                        {data.review_by_user_to_agent}
                      </p>
                    ) : (
                      <p className="review-text-content" style={{ color: "#9ca3af" }}>—</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Rest of your cards remain exactly the same */}
            {/* Address Card */}
            <div className="agent-card">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px"}}>📍 Location Details</h3>
              <div className="card-content">
                <div className="info-row">
                  <span className="info-label">Saved As</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {ToFirstCapital(data?.address?.save_as) || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Address</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.address?.address || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">House/Flat</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.address?.house_flat_floorno || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Area</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.address?.appartment_road_area || "—"}
                  </span>
                </div>

                <div className="info-row">
                  <span className="info-label">Directions</span>
                  <span className="info-value" style={{ fontSize: "15px"}}>
                    {data?.address?.direction_to_reach || "—"}
                  </span>
                </div>

                {latitude && longitude && (
                  <div className="map-container">
                    <iframe
                      title="Location Map"
                      src={`https://www.google.com/maps?q=${latitude},${longitude}&z=15&output=embed`}
                      width="100%"
                      height="280"
                      style={{ border: 0, borderRadius: "16px" }}
                      allowFullScreen=""
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"
                    />
                  </div>
                )}

                {data?.address?.set_as_default && (
                  <div className="info-row">
                    <span className="info-label">Default Address</span>
                    <span className="info-value" style={{ fontSize: "15px"}}>✓ Yes</span>
                  </div>
                )}
              </div>
            </div>

            {/* Projects Card */}
            <div className="agent-cards">
              <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "23px", fontSize: "16px"}}>🏗️ Projects</h3>
              <div className="card-contents">
                {data?.projects?.length > 0 ? (
                  data.projects.map((proj) => (
                    <div key={proj._id} className="project-card-items">
                      <div className="info-rows">
                        <span className="info-labels" style={{ color: "black"}}>Project Name</span>
                        <span className="info-values" style={{ background: "transparent"}}>{proj.project_name}</span>
                      </div>
                      <div className="info-rows">
                        <span className="info-labels" style={{ color: "black"}}>Brand</span>
                        <span className="info-values" style={{ background: "transparent"}}>{proj.brand_name}</span>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="info-rows">
                    <span className="info-values">No projects assigned</span>
                  </div>
                )}
              </div>
            </div>

            {/* Nearby Agents List - Full Width */}
            <div className="agent-card" style={{ gridColumn: "1 / -1" }}>
              <div
                className="card-title-row"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "20px 23px 0px 0px",
                }}
              >
                <h3 style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "14px", margin: "21px 21px 21px 29px", fontSize: "16px", width: "100%"}}>👨‍💼 Nearby Agents List</h3>
                <Link to="/agent">
                  <button className="view-all-btn">View All</button>
                </Link>
              </div>
              <div className="card-content">
                {data?.agent_list?.length > 0 ? (
                  <div className="agents-grid">
                    {data.agent_list.map((agent) => (
                      <div key={agent._id} className="agent-detail-card">
                        <div className="agent-detail-header">
                          {agent.profile_image ? (
                            <img
                              src={agent.profile_image}
                              alt={agent.name}
                              className="agent-detail-avatar"
                            />
                          ) : (
                            <div className="agent-detail-avatar-placeholder">
                              {agent.name?.charAt(0) || "A"}
                            </div>
                          )}
                          <div className="agent-detail-info">
                            <h4 className="agent-detail-name">{agent.name}</h4>
                            <span className="agent-detail-id">
                              Agent Id: {agent.staff_id}
                            </span>
                          </div>
                        </div>
                        <div className="agent-detail-contact">
                          <div className="contact-row">
                            <span className="contact-label">📧 Email</span>
                            <span className="contact-value">{agent.email}</span>
                          </div>
                          <div className="contact-row">
                            <span className="contact-label">📱 Phone</span>
                            <span className="contact-value">
                              {agent.country_code} {agent.contact_number}
                            </span>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="no-data-message">
                    <div className="no-data-icon">👥</div>
                    <p>No agents assigned to this appointment</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      <Modal
        title="User Review"
        open={isReviewModalOpen}
        footer={null}
        onCancel={() => setIsReviewModalOpen(false)}
      >
        <p style={{ whiteSpace: "pre-wrap", lineHeight: "1.6" }}>
          {data?.review_by_user_to_agent || "No review available"}
        </p>
      </Modal>
    </div>
  );
};

export default ViewHomeVisit;
